import type { Locale } from 'date-fns'
import { enUS } from 'date-fns/locale'

import { type LanguageId, LanguageIdEnum } from '@mntn-dev/domain-types'

export const fallbackLanguageId: LanguageId = LanguageIdEnum.en
export const locales: Record<LanguageId, Locale> = { en: enUS } as const
export const fallbackLocale = locales[fallbackLanguageId]

export const defaultNS = 'translation'

export const cookieName = 'i18next'
